const themes = {
  'insitu': {
    light: {
      primary: '#1ca2dc'
    },
    dark: {
      primary: '#74bedd'
    }
  },
  'vivantes': {
    light: {
      primary: '#cc0033',
      error: '#eb4f76',
      success: '#3db58b'
    },
    dark: {
      primary: '#cc0033'
    }
  }
}

export default {
  setTheme ($vuetify, key = 'insitu') {
    if (!$vuetify) {
      return
    }

    const theme = themes[key]

    if (!theme) {
      return
    }

    Object.keys(theme).forEach(key => {
      $vuetify.theme.setTheme(key, theme[key])
    })
  }
}
